// src/features/treasury/components/TreasuryDashboard/index.jsx
import React, { useState } from 'react';
import { useTreasury } from '../../hooks/useTreasury';
import PageHeader from '../../../../shared/components/layout/PageHeader';
import Button from '../../../../shared/components/ui/Button';
import TreasuryStats from './TreasuryStats';
import TransactionsTable from './TransactionsTable';
import TreasuryModals from './TreasuryModals';
import TreasuryReport from './TreasuryReport';
import styles from './TreasuryDashboard.module.css';

const TABS = [
  { id: 'transactions', label: 'حركات الخزينة' },
  { id: 'report',       label: 'التقرير الشامل' },
];

const TreasuryDashboard = () => {
  const {
    treasury, transactions, statistics,
    loading, error, filters,
    handleFilterChange, loadTreasury, loadTransactions,
    currentPage, totalPages, totalCount, pageSize, goToPage,
    loadAllTransactionsForPrint,
  } = useTreasury();

  const [activeTab,   setActiveTab]   = useState('transactions');
  const [activeModal, setActiveModal] = useState(null);

  const handleSuccess = () => {
    setActiveModal(null);
    loadTreasury();
    loadTransactions();
  };

  // ✅ تحديث البيانات بعد الحذف
  const handleRefresh = () => {
    loadTreasury();
    loadTransactions();
  };

  return (
    <div className={styles.container}>
      <PageHeader
        title="نظام الخزينة المركزي"
        actions={
          <>
            <Button variant="success" onClick={() => setActiveModal('deposit')}>+ إيداع نقدي</Button>
            <Button variant="danger"  onClick={() => setActiveModal('withdraw')}>- سحب نقدي</Button>
          </>
        }
      />

      <TreasuryStats treasury={treasury} />

      <div className={styles.tabs}>
        {TABS.map(tab => (
          <button key={tab.id}
            className={`${styles.tabBtn} ${activeTab === tab.id ? styles.activeTab : ''}`}
            onClick={() => setActiveTab(tab.id)}>
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {activeTab === 'transactions' && (
          <TransactionsTable
            transactions={transactions}
            statistics={statistics}
            loading={loading}
            error={error}
            filters={filters}
            onFilterChange={handleFilterChange}
            treasury={treasury}
            onRefresh={handleRefresh}  // ✅ تمرير دالة التحديث
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={goToPage}
            loadAllTransactionsForPrint={loadAllTransactionsForPrint}
          />
        )}
        {activeTab === 'report' && <TreasuryReport />}
      </div>

      <TreasuryModals activeModal={activeModal} onClose={() => setActiveModal(null)} onSuccess={handleSuccess} />
    </div>
  );
};

export default TreasuryDashboard;